import getStepType from 'core/libs/getStepType';
import decodeId from 'core/libs/helpers/decodeId';
import log from 'core/libs/logger';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose, withPropsOnChange} from 'recompose';
import CourseDetails from '../components/CourseDetails';
import {graphql} from '@apollo/client/react/hoc';
import SUBSCRIPTION from '../../degrees/graphql/subscription.graphql';

const CourseDetailsContainer = CourseDetails;

CourseDetailsContainer.propTypes = {
  course: PropTypes.object.isRequired,
  courseSlug: PropTypes.string.isRequired,
  trackSlug: PropTypes.string.isRequired,
  activatedAt: PropTypes.string,
};
const enhance = compose(
  withPropsOnChange(
    ['course'],
    ({course, courseSlug, trackSlug, activatedAt}) => {
      let track = course.trackstepSet.edges.find(
        ({
          node: {
            track: {slug},
          },
        }) => slug === trackSlug,
      );
      let deadline = 0;
      if (track) {
        deadline = track.node.deadline;
        track = track.node.track; // eslint-disable-line prefer-destructuring
      } else {
        log("We didn't find a track for this course ", {
          courseSlug,
          trackSlug,
          currentUrl: typeof window !== 'undefined' && window.location.href,
        });
        track = course.trackstepSet.edges[0].node.track; // eslint-disable-line prefer-destructuring
      }

      return {
        isDegree: !!track.degree,
        ...course,
        deadline,
        activatedAt,
        id: decodeId(course.id),
        trackstepSet: null,
        track: {
          ...track,
          id: decodeId(track.id),
        },
        stageSet: null,
        stages:
          course.stageSet.edges &&
          course.stageSet.edges.map(({node: stage}) => ({
            ...stage,
            id: decodeId(stage.id),
            stepSet: null,
            steps:
              stage.stepSet.edges &&
              stage.stepSet.edges
                .map(({node: step}) => {
                  const id = decodeId(step.id);
                  const ctype = getStepType(step);
                  if (!ctype) {
                    log('This step has no type ??', {
                      id,
                      slug: step.slug,
                      step,
                    });
                  }
                  return {
                    ...step,
                    id,
                    ctype,
                  };
                })
                .sort((a, b) => a.position - b.position),
          })),
        teachers:
          course.teachers &&
          course.teachers.edges &&
          course.teachers.edges.map(({node: teacher}) => teacher),
      };
    },
  ),
  graphql(SUBSCRIPTION, {
    props: ({ data }) => {
      const {error, recurrentPayment, loading} = data;
      if (loading) return {loading};
      if (error) return {error};
      return {subscription: recurrentPayment?.status}
    },
  }),
  connect((state, {id}) => {
    return {
      authenticated: state.auth.authenticated,
      courseProgress:
        (state.user.progress.course && state.user.progress.course[id]) ||
        'not started',
      stagesProgress: state.user.progress.stage || {},
      stepsProgress: state.user.progress.step || {},
    };
  }),
);

export default enhance(CourseDetailsContainer);
